export function getWsUrl() {
  if (import.meta.env.VITE_DREAM_WS_URL) {
    return import.meta.env.VITE_DREAM_WS_URL
  }
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  return `${proto}//${window.location.host}/ws/dream`
}

export function getApiBase() {
  if (import.meta.env.VITE_DREAM_API_URL) return import.meta.env.VITE_DREAM_API_URL
  return ''
}

export function formatUptime(seconds) {
  if (typeof seconds !== 'number') return '—'
  const d = Math.floor(seconds / 86400)
  const h = Math.floor((seconds % 86400) / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  return `${d}d ${String(h).padStart(2, '0')}h ${String(m).padStart(2, '0')}m`
}

export function formatScore(value) {
  return typeof value === 'number' ? value.toFixed(2) : '—'
}

export function shortHash(hash, n = 8) {
  if (!hash) return '—'
  return String(hash).slice(0, n)
}

export function lerp(a, b, t) {
  return a + (b - a) * t
}

export function lerpArray(from, to, t) {
  if (!from || !to) return to || from || []
  const len = Math.max(from.length, to.length)
  return Array.from({ length: len }, (_, i) => lerp(from[i] ?? 0, to[i] ?? 0, t))
}

export function agoLabel(iso) {
  if (!iso) return '—'
  const ms = Date.now() - new Date(iso).getTime()
  if (!Number.isFinite(ms) || ms < 0) return '—'
  const s = Math.floor(ms / 1000)
  if (s < 60) return `${s}s ago`
  return `${Math.floor(s / 60)}m ago`
}
